import {
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Paper,
  Select,
} from "@mui/material";
import { Col, Container, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import React, { Fragment, useEffect, useState } from "react";
import { basicFormValidationHandler, formattedPrice } from "../utils";
import { fetchCartFinish, fetchGetItemsFromCart } from "../actions/global";
import { isEmpty, isUndefined } from "lodash";

import CheckoutProductItem from "../components/CheckoutProductItem";
import ContactFooter from "../components/ContactFooter";
import HeroText from "../components/HeroText";
import InputField from "../components/Reusable/InputField";
import PaymentOptions from "../components/PaymentOptions";
import { UpcPayment } from "upc-payment-js";
import i18next from "i18next";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import HelmetSeo from "../components/Reusable/HelmetSeo";

const CASH_ON_DELIVERY_FEE = 180;
const CASH_ON_DELIVERY_FEE_THRESHOLD = 8000;

const Checkout = () => {
  const { t } = useTranslation();
  const heroData = {
    title: t("pages.checkout_title"),
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { dataCartInfo } = useSelector((state) => state.globalReducer);
  // useEffect(() => {
  //   if (isEmpty(dataCartInfo)) {
  //     navigate("/");
  //   }
  // }, [dataCartInfo, navigate]);

  useEffect(() => {
    dispatch(fetchGetItemsFromCart());
  }, [dispatch]);

  const initialState = {
    email: "",
    name: "",
    surname: "",
    companyName: "",
    address: "",
    apartmentNumber: "",
    postalCode: "",
    city: "",
    phone: "",
    note: "",
    country: "Serbia",
    payment_method: 2,
  };

  const [data, setData] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [isTermsAccepted, setIsTermsAccepted] = useState(false);

  const handleInputChange = (event) => {
    const { name, value, checked, type } = event?.target || {};

    setData((prevUser) => ({
      ...prevUser,
      [name]: value,
    }));
  };

  const getCartInfoFunction = () => {
    dispatch(fetchGetItemsFromCart(dataCartInfo.id, i18next.language));
  };

  const handleInputChangePaymentMethod = (value) => {
    setData((prevUser) => ({
      ...prevUser,
      payment_method: value,
    }));
  };

  const clientValidationHandler = () => {
    const { name, surname, email, address, postalCode, city, phone } = data;
    const errorsObject = basicFormValidationHandler(
      {
        name,
        surname,
        email,
        address,
        postalCode,
        city,
        phone,
      },
      t
    );

    setErrors(errorsObject);

    if (!isEmpty(errorsObject)) {
      toast.error(t("other.required_form_submit"), { theme: "colored" });
    }

    return !isEmpty(errorsObject); // Ako ima grešaka, vraća `true`
  };

  // const handleCheckout = (event) => {
  //   event.preventDefault();

  //   if (!isTermsAccepted) {
  //     toast.error(t("other.terms_accept_form_submit"), {
  //       theme: "colored",
  //     });
  //     return;
  //   }

  //   if (clientValidationHandler()) {
  //     return;
  //   }

  //   data.id_order = dataCartInfo.id;
  //   data.total_amount =
  //     Number(dataCartInfo.total_price_sum) + Number(dataCartInfo.shipping);
  //   dispatch(fetchCartFinish(data, navigate));
  // };

  const handleCheckout = async (event) => {
    event.preventDefault();

    if (!isTermsAccepted) {
      toast.error(t("other.terms_accept_form_submit"), { theme: "colored" });
      return;
    }

    if (clientValidationHandler()) {
      return;
    }

    const payload = {
      ...data,
      onlinePayment: data.payment_method === 2 ? true : false,
      total_amount: totalPriceWithPaymentFee,
    };

    try {
      // Pozivamo novi action koji vraća payment podatke
      const paymentData = await dispatch(fetchCartFinish(payload, navigate));
      // console.log(paymentData, "paymentData-123");
      //ako je placanje karticama
      if (payload.payment_method == 2) {
        // Pravimo redirect POST formu
        redirectToPayment(paymentData);
      }
    } catch (err) {
      // greška je već tretirana u action-u
      console.log(err, "err");
    }
  };

  const redirectToPayment = (paymentData) => {
    // console.log(paymentData, "paymentData");
    // console.log(paymentData?.price, "paymentData?.price");
    // console.log(paymentData?.time, "paymentData?.time");
    // console.log(paymentData?.orderNumber, "paymentData?.orderNumber");
    // console.log(paymentData?.signature, "paymentData?.signature");
    const form = document.createElement("form");
    form.method = "POST";
    // form.action = "https://ecg.test.upc.ua/rbrs/pay";
    form.action = "https://ecommerce.raiffeisenbank.rs/rbrs/pay";

    form.appendChild(createHiddenInput("MerchantID", "217538314538FFD"));
    form.appendChild(createHiddenInput("TerminalID", "4538001D"));
    form.appendChild(createHiddenInput("TotalAmount", paymentData?.price));
    form.appendChild(createHiddenInput("Currency", 941));
    form.appendChild(createHiddenInput("locale", "EN"));
    form.appendChild(createHiddenInput("PurchaseTime", paymentData?.time));
    form.appendChild(createHiddenInput("OrderID", paymentData?.orderNumber));
    // form.appendChild(createHiddenInput("Delay", 0));
    form.appendChild(createHiddenInput("Version", 1));
    form.appendChild(createHiddenInput("Signature", paymentData?.signature));

    document.body.appendChild(form);
    form.submit();
  };

  function createHiddenInput(name, value) {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    return input;
  }

  const handleTermsChange = (event) => {
    setIsTermsAccepted(event.target.checked);
  };

  const baseTotalPrice = Number(
    dataCartInfo?.finalPrice ??
      (Number(dataCartInfo?.totalPrice || 0) +
        Number(dataCartInfo?.shippingPrice || 0))
  );
  const baseShippingPrice = Number(dataCartInfo?.shippingPrice || 0);
  const shouldApplyCashOnDeliveryFee =
    data.payment_method === 1 &&
    baseTotalPrice <= CASH_ON_DELIVERY_FEE_THRESHOLD;
  const cashOnDeliveryFee =
    shouldApplyCashOnDeliveryFee ? CASH_ON_DELIVERY_FEE : 0;
  const shippingPriceWithPaymentFee = baseShippingPrice + cashOnDeliveryFee;
  const totalPriceWithPaymentFee = baseTotalPrice + cashOnDeliveryFee;

  return (
    <div className="checkout-holder-content">
      <HelmetSeo title={"Fuka | " + t("pages.checkout_title")} />
      <div className="container">
        <div className="checkout-hero-holder">
          <HeroText data={heroData} />
        </div>

        <div className="checkout-content-main">
          <div className="checkout-content-form-holder">
            <Paper elevation={1}>
              <Container fluid>
                <div className="checkout-content-form">
                  <div className="checkout-title-info">
                    <h5>{t("payment_page.form.title_1")}</h5>
                  </div>
                  <div className="checkout-content-form-inputs">
                    <Row>
                      <Col md={12}>
                        <InputField
                          id="outlined-basic"
                          label={t("payment_page.form.email")}
                          className="w-100"
                          type="email"
                          name="email"
                          value={data.email}
                          onChange={handleInputChange}
                          error={errors}
                          errorsHandler={setErrors}
                          required
                        />
                      </Col>
                    </Row>
                  </div>
                  <div className="checkout-title-info-section">
                    <h5>{t("payment_page.form.title_2")}</h5>
                  </div>
                  <div className="checkout-content-form-inputs">
                    <Row>
                      <Col md={6}>
                        <InputField
                          id="outlined-basic"
                          label={t("payment_page.form.first_name")}
                          className="w-100"
                          error={errors}
                          errorsHandler={setErrors}
                          required
                          type="text"
                          name="name"
                          value={data.name}
                          onChange={handleInputChange}
                        />
                      </Col>
                      <Col md={6} className="margin-top-mobile-4 mt-md-0">
                        <InputField
                          id="outlined-basic"
                          label={t("payment_page.form.last_name")}
                          className="w-100"
                          name="surname"
                          value={data.surname}
                          onChange={handleInputChange}
                          error={errors}
                          errorsHandler={setErrors}
                          required
                        />
                      </Col>
                      <Col md={12} className="mt-4">
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">
                            {t("payment_page.form.country")}
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={data.country}
                            label={t("payment_page.form.country")}
                            name="country"
                            onChange={handleInputChange}
                          >
                            <MenuItem value={"Serbia"}>Serbia</MenuItem>
                          </Select>
                        </FormControl>
                      </Col>
                      <Col md={6} className="mt-4">
                        <InputField
                          id="outlined-basic"
                          label={t("payment_page.form.company")}
                          className="w-100"
                          name="companyName"
                          value={data.companyName}
                          onChange={handleInputChange}
                        />
                      </Col>
                      <Col md={6} className="mt-4">
                        <InputField
                          id="outlined-basic"
                          label={t("payment_page.form.address")}
                          className="w-100"
                          name="address"
                          value={data.address}
                          onChange={handleInputChange}
                          error={errors}
                          errorsHandler={setErrors}
                          required
                        />
                      </Col>
                      <Col md={6} className="mt-4">
                        <InputField
                          label={t("payment_page.form.apartment")}
                          className="w-100"
                          name="apartmentNumber"
                          value={data.apartmentNumber}
                          onChange={handleInputChange}
                        />
                      </Col>
                      <Col md={6} className="mt-4">
                        <InputField
                          label={t("payment_page.form.postal_code")}
                          className="w-100"
                          name="postalCode"
                          value={data.postalCode}
                          onChange={handleInputChange}
                          error={errors}
                          errorsHandler={setErrors}
                          required
                        />
                      </Col>
                      <Col md={6} className="mt-4">
                        <InputField
                          label={t("payment_page.form.city")}
                          className="w-100"
                          name="city"
                          value={data.city}
                          onChange={handleInputChange}
                          error={errors}
                          errorsHandler={setErrors}
                          required
                        />
                      </Col>
                      <Col md={6} className="mt-4">
                        <InputField
                          label={t("payment_page.form.phone")}
                          className="w-100"
                          type="number"
                          name="phone"
                          value={data.phone}
                          onChange={handleInputChange}
                          error={errors}
                          errorsHandler={setErrors}
                          required
                        />
                      </Col>
                      <Col md={12} className="mt-4">
                        <InputField
                          label={t("payment_page.form.note")}
                          className="w-100"
                          multiline
                          name="note"
                          value={data.note}
                          onChange={handleInputChange}
                          rows={4}
                        />
                      </Col>
                    </Row>
                  </div>
                  <div className="checkout-title-info-section">
                    <h5>{t("payment_page.form.title_3")}</h5>
                  </div>
                  <div className="checkout-payment-holder">
                    <PaymentOptions
                      t={t}
                      selectedPaymentMethod={data.payment_method}
                      handleInputChangePaymentMethod={
                        handleInputChangePaymentMethod
                      }
                    />
                  </div>
                </div>
                <Row>
                  <Col md={12}>
                    <div className="checkout-button-holder">
                      <div className="checout-button-info-policy">
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={isTermsAccepted}
                              onChange={handleTermsChange}
                              required
                            />
                          }
                          label={
                            <Fragment>
                              {t("other.terms_accept")}{" "}
                              <Link
                                to="/privacy-policy"
                                style={{
                                  textDecoration: "none",
                                  color: "#1976d2",
                                }}
                              >
                                {t("menu.policy2")}
                              </Link>{" "}
                            </Fragment>
                          }
                        />
                      </div>
                      <button
                        className="button-custom-black w-100"
                        onClick={handleCheckout}
                      >
                        {t("payment_page.proceed_to_checkout")}
                      </button>
                    </div>
                  </Col>
                </Row>
              </Container>
            </Paper>
          </div>
          <div className="checkout-content-information-items">
            <Paper elevation={1}>
              <div className="checkout-content-main-holder">
                <h3>{t("payment_page.summary")}</h3>
                <div className="checkout-information-summary">
                  <div className="checkout-information-summary-item">
                    <div className="checkout-information-summary-item-title">
                      {t("payment_page.subtotal")}
                    </div>
                    <div className="checkout-information-summary-item-sum">
                      {formattedPrice(dataCartInfo?.totalPrice)}{" "}
                      <small>RSD</small>
                    </div>
                  </div>
                  <div className="checkout-information-summary-item">
                    <div className="checkout-information-summary-item-title">
                      {t("payment_page.shipping")}
                    </div>
                    <div className="checkout-information-summary-item-sum">
                      {formattedPrice(shippingPriceWithPaymentFee)}{" "}
                      <small>RSD</small>
                    </div>
                  </div>
                  <div className="checkout-information-summary-total">
                    <div className="checkout-information-summary-item-title">
                      {t("payment_page.total")}
                    </div>
                    <div className="checkout-information-summary-item-sum">
                      {formattedPrice(totalPriceWithPaymentFee)}{" "}
                      <small>RSD</small>
                    </div>
                  </div>
                </div>
                <div className="checkout-information-list-items">
                  {dataCartInfo?.items?.map((item, key) => (
                    <CheckoutProductItem item={item} key={key} />
                  ))}
                </div>
              </div>
            </Paper>
          </div>
        </div>

        <ContactFooter />
      </div>
    </div>
  );
};

export default Checkout;
